const body = document.querySelector('body')
const toggleMenu = document.querySelector('.toggle--burger')
const navigationDefault = document.querySelector('.navigation--header')
const navTopList = document.querySelector('.navigation--top-list')
const navList = document.querySelector('.navigation--list')
const navPointsA = navigationDefault.querySelectorAll('a.navigation--listitem--link, a.subnavigation--listitem--link')
const navPointsSpan = navigationDefault.querySelectorAll('button.navigation--listitem--link')
const subNavPoints = navigationDefault.querySelectorAll('a.subnavigation--listitem--link, a.nav--button')
const subNavBacks = navigationDefault.querySelectorAll('.subnavigation--back button')
const subNavs = navigationDefault.querySelectorAll('.subnavigation')
const headerNavLinks = navigationDefault.querySelectorAll('button.navigation--listitem--link, a.navigation--listitem--link, .phone--listitem a, a.language--listitem--link')
const firstheaderNavLink = headerNavLinks[0]
const lastheaderNavLink = headerNavLinks[headerNavLinks.length - 1]

// Close Navigation (Mobile)
const closeNavigation = () => {
    toggleMenu.classList.remove('active')
    toggleMenu.setAttribute("aria-label", "Open menu")
    toggleMenu.setAttribute("aria-expanded", "false")
    navigationDefault.classList.remove('active')
    body.classList.remove('no-scroll')
    navigationDefault.setAttribute("aria-hidden", "true")
    headerNavLinks.forEach(link => {
        link.setAttribute('tabindex', '-1')
    })
    adjustCurrent()
}

// Navigation ActiveState
const getState = (item) => {
    const pathnames = location.pathname.split('/').slice(1)
    const pathKey = item.getAttribute('data-name')
    const isActive = pathnames.includes(pathKey)

    if(isActive) {
        item.parentElement.classList.add('current')
        item.setAttribute('aria-current', 'page')
    }
}

// Navigation Check all Links
const adjustCurrent = () => {
    navigationDefault.querySelectorAll('.navigation--listitem--link').forEach(item => {
        getState(item)
    })
}

// Reset NavPoint and its Subnavigation
const resetNavPoint = (item) => {
    const navPoint = item.closest('.navigation--listitem')
    const navPointSubNav = navPoint.querySelector('.subnavigation')

    navPoint.classList.remove('active')
    navPoint.querySelector('button').setAttribute('aria-expanded', 'false');
    navPointSubNav.classList.remove('active')
    navPointSubNav.setAttribute('aria-hidden', 'true')
    navPointSubNav.querySelectorAll('a').forEach(link => {
        link.setAttribute('tabindex', '-1')
    })
    navPoint.querySelector('.subnavigation--back button').setAttribute('tabindex', '-1')
}

// Initialization
// Check States
[...navPointsA, ...navPointsSpan].forEach(item => {
    getState(item);
});
// Set TabIndex of all Subnavigations to -1
[...subNavs,...subNavPoints, ...subNavBacks].forEach(item => {
    item.setAttribute('tabindex', '-1')
});
// Change Order of mobile navigation-lists and Tabindex MainNavPpints
const changeOrderOfNav = () => {
    if(window.innerWidth < 990) {
        navigationDefault.setAttribute('aria-hidden', 'true')
        navTopList.remove()
        navList.after(navTopList)
        headerNavLinks.forEach(link => {
            link.setAttribute('tabindex', '-1')
        })
    }
    if(window.innerWidth >= 990) {
        navigationDefault.setAttribute('aria-hidden', 'false')
        navTopList.remove()
        navList.before(navTopList)
        headerNavLinks.forEach(link => {
            link.setAttribute('tabindex', '0')
        })
    }
}


navPointsSpan.forEach(item => {
    item.addEventListener('click', () => {
        window.value = document.querySelector('body').getBoundingClientRect().top
        const currentNavPoint = item.closest('.navigation--listitem')
        const currentSubNav = currentNavPoint.querySelector('.subnavigation')
        const currentSubNavPoints = currentSubNav.querySelectorAll('.subnavigation a')
        const firstCurrentSubNavLink = currentSubNavPoints[0]
        const lastCurrentSubNavLink = currentSubNavPoints[currentSubNavPoints.length - 1]
        const otherNavPoints = Array.from(document.querySelectorAll('.navigation--header .navigation--list .navigation--listitem')).filter(navPoint => navPoint !== currentNavPoint);

        if (document.querySelector('.navigation--listitem.current')) {
            document.querySelector('.navigation--listitem.current').classList.remove('current')
        }

        currentNavPoint.classList.toggle('active')

        // Aktivate currentNavPoint and its Subnavigation
        if (currentNavPoint.classList.contains('active')) {
            // Activate Navigationitem and SubNavigation + Aria
            currentNavPoint.classList.add('active')
            item.setAttribute('aria-expanded', 'true');
            currentSubNav.classList.add('active')
            currentSubNav.setAttribute('aria-hidden', 'false');

            // Set Tabindex in subnavigation
            currentSubNavPoints.forEach(link => {
                link.setAttribute('tabindex', '0')
            })
            currentSubNav.querySelector('.subnavigation--back button').setAttribute('tabindex', '0')

            firstCurrentSubNavLink.focus()

            // Tab-Trap in Menu
            item.closest('.navigation--listitem').addEventListener('keydown', (event) => {
                if (event.key === 'Tab') {
                    if (event.shiftKey && document.activeElement === firstCurrentSubNavLink) {
                        event.preventDefault()
                        if(window.innerWidth < 990) {
                            currentNavPoint.querySelector('.subnavigation--back button').focus()
                        } else {
                            item.focus()
                        }
                    } else if (!event.shiftKey && document.activeElement === lastCurrentSubNavLink) {
                        event.preventDefault()
                        if(window.innerWidth < 990) {
                            currentNavPoint.querySelector('.subnavigation--back button').focus()
                        } else {
                            item.focus()
                        }
                    }
                }
            })
        }

        // Deaktivate all other items
        otherNavPoints.forEach(otherNavPoint => {
            resetNavPoint(otherNavPoint)
        })
        
        // Deaktivate currentNavPoint and its Subnavigation
        if (!currentNavPoint.classList.contains('active')) {
            resetNavPoint(currentNavPoint)
            adjustCurrent()
        }
    })
})

// Close Navigation if user clicks on link => exspecially for anchorlinks
navPointsA.forEach(item => {
    item.addEventListener('click', () => {
        if(window.innerWidth < 990) {
            closeNavigation()
        }
    })
})

// Open/Close Navigation Mobile
toggleMenu.addEventListener('click', () => {
    toggleMenu.classList.toggle('active')
    navigationDefault.classList.toggle('active')
    body.classList.toggle('no-scroll')

    if(toggleMenu.classList.contains('active')) {
        navigationDefault.setAttribute("aria-hidden", "false")
        toggleMenu.setAttribute("aria-label", "Close menu")
        toggleMenu.setAttribute("aria-expanded", "true")
        headerNavLinks.forEach(link => {
            link.setAttribute('tabindex', '0')
        })
        navPointsSpan[0].focus()

        // Tab-Trap in Mobile Menu
        navigationDefault.addEventListener('keydown', (event) => {
            const currentHeaderNavLinks = navigationDefault.querySelectorAll('button.navigation--listitem--link, a.navigation--listitem--link, .phone--listitem a, a.language--listitem--link')
            const currentFirstheaderNavLink = currentHeaderNavLinks[0]
            const currentLastheaderNavLink = currentHeaderNavLinks[currentHeaderNavLinks.length - 1]
        
            if (window.innerWidth < 990 && event.key === 'Tab') {
                if (event.shiftKey && document.activeElement === currentFirstheaderNavLink) {
                    event.preventDefault()
                    toggleMenu.focus()
                } else if (!event.shiftKey && document.activeElement === currentLastheaderNavLink) {
                    event.preventDefault()
                    toggleMenu.focus()
                }
            }
        })
    }
    if(!toggleMenu.classList.contains('active')) {
        closeNavigation()
    }
})

/// Desktop Close SubNavigation
//Click back on mobile
subNavBacks.forEach(item => {
    item.addEventListener('click', () => {
        resetNavPoint(item)
        item.closest('.navigation--listitem').querySelector('.navigation--listitem--link').focus()
        adjustCurrent()
    })
})

// Click outside
window.addEventListener('click', event => {
    navigationDefault.querySelectorAll('.subnavigation.active').forEach(item => {
        if (!document.querySelector('header').contains(event.target)) {
            resetNavPoint(item)
            adjustCurrent()
        }
    })
})

// Scroll
window.addEventListener('scroll', () => {
    navigationDefault.querySelectorAll('.subnavigation.active').forEach(item => {
        if(item) {
            if(window.innerWidth >= 900) {
                const documentCurrentPosition = document.querySelector('body').getBoundingClientRect().top
                const difference = window.value + documentCurrentPosition * -1

                if (difference >= 200 || difference <= -200) {
                    resetNavPoint(item)
                    adjustCurrent()
                }
            }
        }
    })
})

window.addEventListener('resize', () => {
    changeOrderOfNav()
});

changeOrderOfNav()